var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeselectAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 1.16675C1.39085 1.16675 1.16699 1.39061 1.16699 1.66675V13.3334C1.16699 13.6096 1.39085 13.8334 1.66699 13.8334H3.66699V15.8334C3.66699 16.1096 3.89085 16.3334 4.16699 16.3334H6.16699V18.3334C6.16699 18.6096 6.39085 18.8334 6.66699 18.8334H18.3337C18.6098 18.8334 18.8337 18.6096 18.8337 18.3334V6.66675C18.8337 6.39061 18.6098 6.16675 18.3337 6.16675H16.3337V4.16675C16.3337 3.89061 16.1098 3.66675 15.8337 3.66675H13.8337V1.66675C13.8337 1.39061 13.6098 1.16675 13.3337 1.16675H1.66699ZM15.3337 6.16675V4.66675H4.66699V15.3334H6.16699V6.66675C6.16699 6.39061 6.39085 6.16675 6.66699 6.16675H15.3337ZM3.66699 4.16675V12.8334H2.16699V2.16675H12.8337V3.66675H4.16699C3.89085 3.66675 3.66699 3.89061 3.66699 4.16675ZM7.16699 17.8334V7.16675H17.8337V17.8334H7.16699Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeselectAll);
export default __webpack_public_path__ + "static/media/deselect-all.cfea02b46c3f4c0ac75beffdc51d744e.svg";
export { ForwardRef as ReactComponent };